import api from "../utils/API";

// Base URL for your API
export const productService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/product", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  fetchOptionList: async () => {
    try {
      const response = await api.get("/admin/product/all");
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  createProduct: async (payload) => {
    try {
      const response = await api.post("/admin/product", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  updateProduct: async (id, payload) => {
    try {
      const response = await api.put(`/admin/product/${id}`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  deleteProduct: async (id) => {
    try {
      const response = await api.delete(`/admin/product/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchProductById: async (id) => {
    try {
      const response = await api.get(`/admin/product/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  resendInvitation: async (id) => {
    try {
      const response = await api.put(`/admin/product/resend-invitation/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
